(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("cloud-ui.vusion"));
	else if(typeof define === 'function' && define.amd)
		define("LcapClock", ["cloud-ui.vusion"], factory);
	else if(typeof exports === 'object')
		exports["LcapClock"] = factory(require("cloud-ui.vusion"));
	else
		root["LcapClock"] = factory(root["CloudUI"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__9dc0__) {
return 